import { useState, useEffect } from "react";                    
import swal from 'sweetalert2';                     
import { getCancelGstReportData } from "../api/reportsAPI";
import moment from "moment";
import RateBar from "./ratebar";

const CancellationGstReport = (props) => {

    const [selectedFromDate,                setSelectedFromDate]      = useState(moment().toDate());
    const [selectedToDate,                  setSelectedToDate]        = useState(moment().toDate());
    const [isInit,                          setIsInit]                = useState(true);
    const [gstCancellationReport,           setGstCancellationReport] = useState(null);
    const [gstCancelTable,                  setGstCancelTable]        = useState(null);
    const [rateDetails,                     setRateDetails]           = useState({
        totalAmount: 0,
        totalTax: 0,
        finalAmount: 0,
        fromDate: '',
        toDate: '',
        total: 0,
        totalBooking: 0,
        type: "Total Bookings"
    });
    
    useEffect(() => {
        props.title('Cancellation GST Report', 'tee-cancellation-gst-report');

        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        });

        getCancellationGstReport();
    }, []);

    useEffect(() => {
        if (!isInit) {
            fillTable();
        }
    }, [gstCancellationReport]);

    useEffect(() => {
        if (gstCancellationReport && gstCancellationReport.CancelGstSheet && gstCancellationReport.CancelGstSheet.length > 0) {
            let totalAmount         = gstCancellationReport.CancelGstSheet.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            totalAmount             = totalAmount.toFixed(2)
            let totalTax            = (parseFloat(totalAmount) * 18) / 100;
            totalTax                = totalTax.toFixed(2);
            let finalAmount         = parseFloat(totalAmount) + parseFloat(totalTax);
            finalAmount             = Math.round(finalAmount);
            finalAmount             = finalAmount.toFixed(2);

            setRateDetails({
                totalAmount,
                totalTax,
                finalAmount,
                fromDate: moment(selectedFromDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                toDate: moment(selectedToDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                total: gstCancellationReport.CancelGstSheet.length,
                type: 'Total Cancellation'
            });
        }
        else {
            setRateDetails({ 
                totalAmount: 0,
                totalTax: 0,
                finalAmount: 0,
                fromDate: moment(selectedFromDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                toDate: moment(selectedToDate, 'DD-MM-YYYY').format('DD MMM, YYYY'),
                total: 0,
                type: 'Total Cancellation'
            });
        }
    },[gstCancellationReport]);

    const getCancellationGstReport = async() => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            const response = await getCancelGstReportData(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'));

            if (response.status == 'error') {
                swal.fire({
                    icon: 'info',
                    titleText: 'No Data',
                    text: 'No data found for specified dates'
                });
                return;
            }
            isInit ? setIsInit(false) : $('#tblTeeGstReport').KTDatatable().destroy();
            setGstCancellationReport(response);
            swal.close();
        } catch (err) {
            swal.fire({
                icon      : 'error',
                titleText : err.message
            });
        }
    };

    function fillTable() {
        swal.close();
        const cancelGstSheet = gstCancellationReport.CancelGstSheet;

        const tblGstSheet = $('#tblTeeGstReport').KTDatatable({
            data: {
                saveState: false,
                source: cancelGstSheet.sort((a, b) => new Date(a.BookDate) - new Date(b.BookDate))
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'TransactionDate',
                    title: 'Bill Dt',
                    width: 55,
                    template: function (row) {
                        if (row.TransactionDate == null) {
                            return "";
                        } else {
                            return moment(row.TransactionDate).format('DD-MM-YYYY');
                        }
                    }
                },
                {
                    field: 'CancelDate',
                    title: 'Cancel Dt & Time',
                    width: 120,
                    template: function (row) {
                        if (row.CancelDate == null) {
                            return '';
                        } else {
                            return moment(row.CancelDate).format('DD-MM-YYYY h:mm');
                        }
                    }
                },
                {
                    field: 'BookDate',
                    title: 'Game Dt',
                    template: function(row) {
                        if (row.BookDate == null) {
                            return '';
                        } else {
                            return moment(row.BookDate).format('DD-MM-YYYY');
                        }
                    }
                },
                {
                    field: 'Slot',
                    title: 'Slot',
                    width: 60
                },
                {
                    field: 'TeeBox',
                    title: 'Tee',
                    width: 80
                },
                {
                    field: 'Hole',
                    title: 'Holes',
                    width: 60
                },
                {
                    field: 'TotalPlayer',
                    title: 'Players',
                    width: 60
                },
                {
                    field: 'SubCategoryName',
                    title: 'Member Category'
                },
                {
                    field: 'TempMembershipTypeName',
                    title: 'Membership Category'
                },
                {
                    field: 'MembershipNo',
                    title: 'Mem. No'
                },
                {
                    // field: 'BookedBy',
                    field: 'CancelledBy',
                    title: 'Cancelled By'
                },
                {
                    field: 'PaymentType',
                    title: 'Pay. Type'
                },
                {
                    field: 'PaymentModeName',
                    title: 'Pay. Mode'
                },
                {
                    field: 'TrackingID',
                    title: 'Tracking ID',
                    width: 190
                },
                {
                    field: 'BillNo',
                    title: 'Bill No',
                    width: 140
                },
                {
                    field: 'FinalAmount',
                    title: 'Bill Amt'
                },
                {
                    field: 'RefundAmount',
                    title: 'Refund Amt'
                },
                {
                    field: 'RefundRefNo',
                    title: 'Refund Ref.No'
                },
                {
                    field: 'RefundStatus',
                    title: 'Refund Sts',
                    template: function (row) {
                        if(!!row?.RefundStatus){
                            if (row.RefundStatus == 'Pending') {
                                return "<span class='label label-warning'>" + row.RefundStatus + "</span>";
                            } else if (row.RefundStatus == 'Processed') {
                                return "<span class='label label-success'>" + row.RefundStatus + "</span>";
                            } else {
                                return "<span class='label label-danger'>" + row.RefundStatus + "</span>";
                            }
                        }else{
                            return "";
                        }
                    }
                },
                {
                    field: 'CompanyName',
                    title: 'Company'
                },
                {
                    field: 'GSTNumber',
                    title: 'GST No'
                }
            ],
            rows: {
                autoHide: false,
            }
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblTeeGstReport .kt-datatable__table').addClass('overflow-x-auto');

        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');

        const CancellationGstTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment(selectedFromDate, "DD-MM-YYYY").format("DD-MM-YYYY")} - To - ${moment(selectedToDate, "DD-MM-YYYY").format("DD-MM-YYYY")} - Cancellation GST Report`
        });

        setGstCancelTable(CancellationGstTable);
        $('.tableexport-caption').addClass('hidden');
    }

    function exportSheet(type) {
        let fileName = `${moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} - To - ${moment(selectedToDate, 'DD-MM-YYYY').format("DD-MM-YYYY")} - Cancellation GST Report`;
        gstCancelTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: fileName // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }


    const validateDate = async() => {
        let isValid = true;

        if (moment(selectedToDate, 'DD-MM-YYYY').isBefore(moment(selectedFromDate, 'DD-MM-YYYY'))) {
            isValid = false;
            swal.fire({
                icon                : 'error',
                titleText           : 'Oops..',
                text                : 'To Date should be greater than From Date',
                buttonsStyling      : false,
                confirmButtonClass  : "btn btn-brand"
            });
            return;
        }
        if (isValid) {
            getCancellationGstReport();
        }
    };

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">From Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date"
                                                readOnly={ true }
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">To Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date"
                                                readOnly={ true }
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')}
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <button className="btn btn-label-success" type="button" id="btnSearch" aria-haspopup="true" aria-expanded="false" onClick={() => validateDate()}>
                                            <i className="la la-search"></i>
                                        </button>
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch"
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <RateBar 
                                rateDetails = { rateDetails }
                            />
                            <div id="tblTeeGstReport" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CancellationGstReport;